<template>
  <div id="app">
    <div class="nav-top">
      <AppNavbar/>
    </div>
    <Transition name="transition-pages" mode="out-in">
      <router-view class="page"></router-view>
    </Transition>
  </div>
</template>

<script setup>
import AppNavbar from './components/AppNavbar.vue';
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
#app{
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--app-bg,#f0f0f0);
}
.page {
  overflow-x: hidden;
  padding: 2rem 2rem;
  flex: 1;
}
.app-footer {
  padding: 1rem;
  position: relative;
  z-index: 10;
}
.nav-top{
  position: fixed;
  width: 100%;
  z-index: 999;
}
.transition-pages-enter-from,
.transition-pages-leave-to{
  opacity: 0;

}
.transition-pages-enter-to,
.transition-pages-leave-from{
  opacity: 1;

}
.transition-pages-enter-active,
.transition-pages-leave-active{
  transition: all 0.5s ease;
}
</style>